import { useTranslation } from 'react-i18next';

export default function CTASection({
  primaryHref = '#contact',
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}) {
  const { t } = useTranslation();
  
  return (
    <section className="py-24 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
      <div className="max-w-5xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-6">{t('cta.title')}</h2>
        <p className="text-blue-100 max-w-2xl mx-auto mb-10">{t('cta.subtitle')}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={primaryHref}
            target={primaryHref.startsWith('http') ? '_blank' : undefined}
            rel={primaryHref.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="inline-block px-10 py-4 bg-white text-blue-600 font-semibold rounded-md shadow hover:shadow-lg hover:scale-[1.02] transition"
            aria-label={primaryLabel || t('cta.quote')}
          >
            {primaryLabel || t('cta.quote')}
          </a>
          {secondaryHref && (
            <a
              href={secondaryHref}
              target={secondaryHref.startsWith('http') ? '_blank' : undefined}
              rel={secondaryHref.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="inline-block px-10 py-4 bg-white/10 text-white font-semibold rounded-md shadow hover:bg-white/20 hover:shadow-lg hover:scale-[1.02] border border-white/30 transition"
              aria-label={secondaryLabel || t('cta.whatsapp')}
            >
              {secondaryLabel || t('cta.whatsapp')}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
